import React from 'react';

import { getTranslation } from 'helpers/getTranslation';

import { Typography } from 'components/shared/Typography';

import { FormikField } from 'components/FormikField';
import { EditableTextField } from 'components/FormikFields';

import styles from './Question.module.scss';

const Question = ({ readOnly }: { readOnly: any }) => (
  <>
    <Typography
      className={styles.title}
      variant="body1"
      weight="medium"
      mode="compact"
    >
      {getTranslation('difference_lesson_page.question.title')}
    </Typography>
    <FormikField
      name="text"
      withControl={false}
      component={EditableTextField}
      componentProps={{
        readOnly,
        className: styles.text,
        variant: 'text',
        placeholder: getTranslation(
          'difference_lesson_page.question.placeholder',
        ),
      }}
    />
  </>
);

export default React.memo(Question) as any;
